<template>
	<div class="modal is-active">
		<div class="modal-background" @click="$emit('close')"></div>
		<div class="modal-card">
			<header class="modal-card-head">
				<h5 class="modal-card-title title is-5">
					{{ translations.title }}
				</h5>
				<button class="delete" aria-label="close" @click="$emit('close')"></button>
			</header>
			<section class="modal-card-body" style="overflow-y: hidden;">
				<h1 class="title-amount title is-1 is-clickable track-action"
					@click="copy((amount/100).toString().replace('.', ','))"
					data-ta-event="clientarea-track.invoice.copy.payment-values"
					data-ta-action="Click"
					data-ta-label="Invoice-page – Copy the payment values"
					data-ta-page-name="InvoicePage"
					:data-ta-payload="JSON.stringify({'amount': (amount/100).toString().replace('.', ',') + '€'})"
				>
					<span class="is-flex is-align-items-center has-gap-16">
						{{ amount|formatAmount }}&nbsp;&euro;
						<span class="icon is-size-4"><i class="fa-light fa-copy"></i></span>
					</span>
				</h1>
				<div v-if="type==='wire'">
					<h4 class="title is-4" v-if="qrcode !== null">
						{{ translations.payment.wire_qrcode }}
					</h4>
					<h4 class="title is-4" v-else>
						{{ translations.payment.wire }}
					</h4>
				</div>
				<div v-else>
					<h4 class="title is-4">
						{{ translations.payment.sdd }}
					</h4>
					<div class="columns is-marginless-bottom">
						<div class="column">
							{{ translations.payment.sdd_reference }}
							&nbsp;
							<span class="is-clickable track-action"
								  @click="copy(reference)"
								  data-ta-event="clientarea-track.invoice.copy.payment-values"
								  data-ta-action="Click"
								  data-ta-label="Invoice-page – Copy the payment values"
								  data-ta-page-name="InvoicePage"
								  :data-ta-payload="JSON.stringify({'reference': reference})"
							>
							{{ reference }}
							<span class="icon"><i class="fa-light fa-copy"></i></span>
						</span>
						</div>
					</div>
					<hr>
				</div>
				<div class="columns">
					<div class="column">
						<br>
						<div class="is-uppercase">{{ translations.iban }}</div>
						<div class="financial-infos is-clickable track-action"
							 @click="copy(iban.replace(/\s/g, ''))"
							 data-ta-event="clientarea-track.invoice.copy.payment-values"
							 data-ta-action="Click"
							 data-ta-label="Invoice-page – Copy the payment values"
							 data-ta-page-name="InvoicePage"
							 :data-ta-payload="JSON.stringify({'iban': iban})"
						>
							{{ iban }}
							<span class="icon"><i class="fa-light fa-copy"></i></span>
						</div>
					</div>
					<div class="column">
						<br>
						<div class="is-uppercase">{{ translations.bic }}</div>
						<div class="financial-infos is-clickable track-action"
							 @click="copy(bic)"
							 data-ta-event="clientarea-track.invoice.copy.payment-values"
							 data-ta-action="Click"
							 data-ta-label="Invoice-page – Copy the payment values"
							 data-ta-page-name="InvoicePage"
							 :data-ta-payload="JSON.stringify({'bic': bic})"
						>
							{{ bic }}
							<span class="icon"><i class="fa-light fa-copy"></i></span>
						</div>
					</div>
				</div>
				<div class="columns">
					<div class="column">
						<div class="is-uppercase">
							{{ translations.communication }}
						</div>
						<div class="financial-infos is-clickable"
							 @click="copy(communication)"
							 data-ta-event="clientarea-track.invoice.copy.payment-values"
							 data-ta-action="Click"
							 data-ta-label="Invoice-page – Copy the payment values"
							 data-ta-page-name="InvoicePage"
							 :data-ta-payload="JSON.stringify({'communication': communication})"
						>
							+++ {{ communication }} +++
							<span class="icon"><i class="fa-light fa-copy"></i></span>
						</div>
					</div>
					<div class="column is-hidden-mobile" v-if="type === 'wire' && qrcode !== null">
						<img :src="qrcode" width="100" height="100">
					</div>
				</div>
				<div class="columns">
					<div class="column" v-if="issuing_date===''">
						{{ translations.comment }}
					</div>
					<div class="column" v-else>
						{{ translations.comment_with_issue_date.replace(':date', issuing_date) }}
					</div>
				</div>
			</section>
			<footer class="modal-card-foot">
				<div class="container">
					<div class="columns">
						<div class="column">
							<button class="button is-medium is-full-width" @click="$emit('close')">{{ translations.close }}</button>
						</div>
					</div>
				</div>
			</footer>
		</div>
	</div>
</template>

<script>
	export default {
		props: [
			'translations',
			'type',
			'amount',
			'iban',
			'bic',
			'communication',
			'reference',
			'issuing_date',
			'qrcode',
		],
		methods: {
			copy: function (value)
			{
				this.$copyText(value).then(() => {
					this.$toasted.show(this.translations.clipboardToast, {duration: 2500, position: 'bottom-center', fullWidth: true});
				});
			}
		},
		filters: {
			formatAmount: function (amount)
			{
				// Switching from cents to euros
				let formattedAmount = amount / 100;
				// Formatting price from 123456,78 to 123 456,78
				return formattedAmount.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ' ').replace('.', ',');
			}
		}
	}
</script>
